import '@ssml-editor/vue';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { a as Element } from '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';

const voidElementPlugin = (editor) => {
  const { insertNode } = editor;
  const newEditor = editor;
  newEditor.insertNode = (node) => {
    insertNode(node);
    if (Element.isElement(node) && newEditor.isVoid(node)) {
      newEditor.move({ distance: 1 });
    }
  };
  return newEditor;
};

export { voidElementPlugin };
//# sourceMappingURL=void-element-plugin.js.map
